import { AlertCircle } from "lucide-react"

interface ErrorAlertProps {
  message: string
}

export function ErrorAlert({ message }: ErrorAlertProps) {
  return (
    <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-start gap-3">
      <AlertCircle className="text-red-500 flex-shrink-0 mt-0.5" size={20} />
      <div>
        <p className="text-red-800 font-medium">Submission Error</p>
        <p className="text-red-600 text-sm mt-1">{message}</p>
      </div>
    </div>
  )
}
